var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_2920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0008 28.5202C21.7332 28.5202 28.0016 22.1357 28.0016 14.2601C28.0016 6.38445 21.7332 0 14.0008 0C6.26837 0 0 6.38445 0 14.2601C0 22.1357 6.26837 28.5202 14.0008 28.5202Z",
    fill: "#FFA600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0694 6.62285C19.4808 6.62285 19.8143 6.28317 19.8143 5.86416C19.8143 5.44514 19.4808 5.10547 19.0694 5.10547C18.658 5.10547 18.3245 5.44514 18.3245 5.86416C18.3245 6.28317 18.658 6.62285 19.0694 6.62285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8798 4.3469C15.8798 4.76622 15.5466 5.10559 15.1349 5.10559C14.7232 5.10559 14.3916 4.76622 14.3916 4.3469C14.3916 3.92758 14.7232 3.58984 15.1349 3.58984C15.5466 3.58984 15.8798 3.92921 15.8798 4.3469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9652 9.62454C16.44 10.9461 15.4174 11.7674 14.6821 11.4622C13.95 11.1601 13.78 9.8448 14.3083 8.52322C14.8335 7.20478 15.8561 6.38351 16.5914 6.68558C17.3267 6.99081 17.4935 8.3061 16.9652 9.62454Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_2920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28.5185,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressIcon);
export default __webpack_public_path__ + "static/media/in_progress_icon.0cb33624e4ace252f2bd913cc41c13c1.svg";
export { ForwardRef as ReactComponent };